import React from "react";

const AreaDetailsPopup = ({
    open,
    areas = [],
    title = "Applicable Areas",
    onClose
}) => {
    const [search, setSearch] = React.useState("");

    if (!open) return null;

    const filteredAreas = areas.filter(area =>
        area.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="area-popup-backdrop" onClick={onClose}>
            <div
                className="area-popup"
                onClick={(e) => e.stopPropagation()}
            >
                {/* HEADER */}
                <div className="area-popup-header">
                    <span>
                        {title} ({areas.length})
                    </span>
                    <button onClick={onClose}>✕</button>
                </div>

                {/* SEARCH */}
                {areas.length > 0 && (
                    <input
                        type="text"
                        placeholder="Search"
                        className="area-search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                )}

                {/* BODY */}
                <div className="area-popup-body">
                    {filteredAreas.length > 0 ? (
                        filteredAreas.map((area, index) => (
                            <span key={index} className="detail-chip">
                                {area}
                            </span>
                        ))
                    ) : (
                        <span className="empty-text">
                            No matching areas
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AreaDetailsPopup;
